import { render } from "./VerificationPrivacy.vue?vue&type=template&id=4c649c08&scoped=true"
import script from "./VerificationPrivacy.vue?vue&type=script&lang=js"
export * from "./VerificationPrivacy.vue?vue&type=script&lang=js"

import "./VerificationPrivacy.vue?vue&type=style&index=0&id=4c649c08&scoped=true&lang=scss"
import "./VerificationPrivacy.vue?vue&type=style&index=1&id=4c649c08&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c649c08"]])

export default __exports__